import { MbscModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { SharedModule } from './shared/shared.module';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MY_DATE_FORMATS } from './modules/settings/holidays/create-holiday/create-holiday.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CoreModule } from './core/core.module';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { pendingChangesGuard } from './shared/module/unsaved-changes';

@NgModule({
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
    declarations: [AppComponent],
    providers: [
        provideAnimationsAsync(),
        provideHttpClient(withFetch()),
        {
            provide: 'pendingChangesGuard',
            useValue: pendingChangesGuard
        },
        DatePipe,
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS } // Replace MY_DATE_FORMATS with your custom date formats if needed
    ],
    bootstrap: [AppComponent],
    imports: [
        MbscModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        MatDatepickerModule,
        MatNativeDateModule,
        CoreModule,
    ]
})
export class AppModule {}
